import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useNavigate, useParams } from "react-router-dom"
import { toast } from "sonner"
import { type JobInput, jobsApi } from "@/api/jobs"
import { ApiError } from "@/api/client"
import { JobForm } from "@/components/dashboard/job-form"
import { PageHeader } from "@/components/dashboard/page-header"
import { DetailPageSkeleton } from "@/components/shared/loading-skeletons"

export function JobEditPage() {
  const { id = "" } = useParams()
  const nav = useNavigate()
  const qc = useQueryClient()
  const job = useQuery({
    queryKey: ["job", id],
    queryFn: () => jobsApi.get(id),
    enabled: !!id,
  })

  async function onSubmit(values: JobInput) {
    try {
      await jobsApi.update(id, values)
      qc.invalidateQueries({ queryKey: ["jobs"] })
      qc.invalidateQueries({ queryKey: ["job", id] })
      toast.success("İlan güncellendi.")
      nav(`/dashboard/jobs/${id}`)
    } catch (err) {
      toast.error(err instanceof ApiError ? err.message : "Güncellenemedi.")
      throw err
    }
  }

  if (job.isLoading) return <DetailPageSkeleton />
  if (!job.data) return <p className="p-6 text-muted-foreground">İlan bulunamadı.</p>

  return (
    <>
      <PageHeader title={`${job.data.data.title} — düzenle`} />
      <div className="p-6">
        <JobForm
          initial={job.data.data}
          submitLabel="Değişiklikleri kaydet"
          onSubmit={onSubmit}
          onCancel={() => nav(`/dashboard/jobs/${id}`)}
        />
      </div>
    </>
  )
}
